import get from 'lodash/get';
import { replaceRichText } from 'src/common/utils/text-replace';
import { date } from 'src/common/utils/date-time-formatter';
import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

export const createCountryOptions = props => Array.from(get(props, 'model.eagleModel.countries', []))
  .filter(eagleCountry => eagleCountry !== 'UM')
  .map(eagleCountry => {
    const prismicCountry = get(props, 'countries.country.countryOption', []).find(country => {
      return country.code === eagleCountry;
    });
    return {
      value: eagleCountry,
      label: get(prismicCountry, 'name', eagleCountry),
    };
  });

// match country from Prismic Country List / Flags with selected country
export const selectedCountry = (props, selectedCountryIso) => {
  const flagCountryOptions = get(props, 'model.prismicCountryListModel.flags.countries', []);
  const country = flagCountryOptions.find(country =>
    country.code === selectedCountryIso);
  return country;
};

export const filterShippingMethods = (field, shippingMethods, countryModel) => {
  return {
    ...field,
    items: field.items.map(item => {
      const availableShippingMethod = shippingMethods.find(shipping => shipping.method.type === item.value) || {};
      const translatedDate = date(
        get(availableShippingMethod, 'delivery.latest'),
        countryModel,
        {
          day:'numeric',
          month: 'long',
          year: 'numeric'
        }
      );
      const description = item.description.map((desc, idx) => {
        if (idx === 0) {
          let text = desc.text;
          // Strip any astrix that came from Prismic to ensure that the
          // DOM element that is rendered will be a strong element.
          if (text.startsWith('*')) {
            text = text.replace(/[*]g/, '');
          }
          return {
            ...desc,
            text:`**${text}**`,
          };
        }
        return desc;
      });
      return {
        ...item,
        ...availableShippingMethod,
        value: availableShippingMethod.id,
        description: replaceRichText(description, {
          date: startCase(toLower(translatedDate)),
          carrier: get(availableShippingMethod, 'method.carrier'),
        }),
        isPreSelected: availableShippingMethod.selected
      };
    }).filter(item => item.id),
  };
};





// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/helpers.js